export default __webpack_public_path__ + "static/media/visa-case-study.13b2e446.png";